type ToastType = "error" | "success" | "info";

interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

type Listener = (toasts: Toast[]) => void;

let toasts: Toast[] = [];
const listeners = new Set<Listener>();

function notify() {
  for (const listener of listeners) {
    listener([...toasts]);
  }
}

function remove(id: string) {
  toasts = toasts.filter((t) => t.id !== id);
  notify();
}

function add(message: string, type: ToastType, duration = 5000) {
  const id = crypto.randomUUID();
  toasts = [...toasts, { id, message, type }];
  notify();
  setTimeout(() => remove(id), duration);
}

export const toast = {
  error: (message: string) => add(message, "error", 6000),
  success: (message: string) => add(message, "success", 4000),
  info: (message: string) => add(message, "info", 4000),
  subscribe: (listener: Listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getToasts: () => [...toasts],
  dismiss: remove,
};
